import dayjs from 'dayjs';
import { get, post } from './fetch';

export interface Special {
  id?: number;
  title: string;
  description: string;
  period: {start: dayjs.Dayjs, end: dayjs.Dayjs}
  users?: string[];
  materials?: any;
  status?: number;
  usersCount: number;
}

export const saveSpecial = async (special: Special): Promise<Special> => {
  const period = { start: special.period.start.format('YYYY-MM-DD'), end: special.period.end.format('YYYY-MM-DD') }
  return await post('/special/save', { ...special, period: period });
};

export const listSpecial = async (
    page: number | undefined = 1,
    pageSize: number = 10,
    search: string,
    state: number,
    sortField?: string,
    sortOrder?: 'ASC' | 'DESC'
):  Promise<{rows: Array<Special>, count: number}> => {
  const params = new URLSearchParams({
    page: (page - 1).toString(),
    pageSize: pageSize.toString(),
    state: state.toString(),
    name: search || '',
  });

  if (sortField) {
    params.append('sortField', sortField);
    params.append('sortOrder', sortOrder || 'ASC');
  }

  return await get(`/special/list?${params.toString()}`);
};

export const oneSpecial = async (id: number):  Promise<Special> => {
  return await get('/special/one?id='+id);
};

export const changeStatusSpecial = async (id: number, status: number):  Promise<Special> => {
  return await get('/special/status?id='+id+'&status='+status);
}; 

export const deleteSpecial = async (id: number):  Promise<boolean> => {
  return await get('/special/delete?id='+id);
}; 